<template>
  <v-btn @click="createItem" color="primary" target="_blank" elevation="0">
    <v-icon left> mdi-plus </v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t('item.action.create') }}
    </span>
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ItemsHeaderActions',

  methods: {
    ...mapActions(['handleOpenCreateEditItemModal']),

    createItem() {
      this.handleOpenCreateEditItemModal()

      const createItem = this.$parent?.$parent?.$refs.rentOutRouterView?.$refs.createItem
      this.$nextTick(() => createItem.resetItemFields())
    },
  },
}
</script>
